import script from "./LegalPolicy.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegalPolicy.vue?vue&type=script&setup=true&lang=ts"

import "./LegalPolicy.vue?vue&type=style&index=0&id=35a4073b&lang=css"

const __exports__ = script;

export default __exports__